module.exports = __webpack_public_path__ + "img/default-avatar.f3eb9186.svg";